import { createRouter } from '@tanstack/react-router';

import { ErrorDistributor } from './common/Error/ErrorDistributor';
import { NotFoundErrorPage } from './common/Error/NotFoundErrorPage';
import { queryClient } from './lib/queryClient';
import { navigationHistory } from './navigation/navigationHistory';
import { routeTree } from './routeTree.gen';

export const router = createRouter({
    routeTree,
    history: navigationHistory,
    basepath: '/app/',
    context: {
        queryClient,
        // auth will be provided by the RouterProvider wrapper
        auth: undefined!,
    },
    defaultPreload: 'intent',
    defaultPreloadDelay: 100,
    defaultPreloadStaleTime: 0,
    defaultErrorComponent: ErrorDistributor,
    defaultNotFoundComponent: NotFoundErrorPage,
});
